// Acciones asincronas que pueden llamar una inforrmacion
// export const myActon = async ({ commit }) => {

// }

import {    
    insertInvestigator,    
  } from "../helpers/services";


  // Inserta investigador
export const insertInvestigators = async (context, values) => {
    const { data } = await insertInvestigator(values);   
    return data;
  };